import { ReactElement } from 'react';
import { DatasetDetailsProjectsTabContainer } from '../../../modules/datasets/containers/DatasetDetailsProjects.container';

export const DatasetDetailsProjectsView = (): ReactElement => <DatasetDetailsProjectsTabContainer />;
